import BootstrapMessaging from "./BootstrapMessaging";

const ChatWrapper = () => {
    const isCustomerLoggedIn = window.magentoData?.is_logged_in || false;

    if (!isCustomerLoggedIn) {
        return null;
    }

    return (
        <div className="App">
            <header className="App-header">
                <BootstrapMessaging />
            </header>
        </div>
    );
}

export default ChatWrapper;
